var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_909_77526",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(180 12 12)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_909_77526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.425 2.45C6.55833 2.45 6.6875 2.475 6.8125 2.525C6.9375 2.575 7.04167 2.64167 7.125 2.725L11.725 7.325C11.9083 7.50833 12 7.74167 12 8.025C12 8.30833 11.9083 8.54167 11.725 8.725C11.5417 8.90833 11.3083 9 11.025 9C10.7417 9 10.5083 8.90833 10.325 8.725L6.425 4.825L2.525 8.725C2.34167 8.90833 2.10833 9 1.825 9C1.54167 9 1.30833 8.90833 1.125 8.725C0.941667 8.54167 0.849999 8.30833 0.849999 8.025C0.849999 7.74167 0.941667 7.50833 1.125 7.325L5.725 2.725C5.825 2.625 5.93333 2.55417 6.05 2.5125C6.16667 2.47083 6.29167 2.45 6.425 2.45Z",
    fill: "#2EBF93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f4028e83d78f3d5ac8ccb9872e55aedf.svg";
export { ForwardRef as ReactComponent };